import { axiosReq } from "utils";
import { CertificatesActions } from "./CertificateReducer";
import { toast } from "sonner";

export const getAllCertificates = (params, getToken) => async (dispatch) => {
  try {
    const token = await getToken();
    dispatch(CertificatesActions.getCertificatesRequest());

    const response = await axiosReq({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/certificate/user`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    dispatch(CertificatesActions.getCertificatesSuccess(response.data));
  } catch (error) {
    toast.error(error.response?.data.message || error.message);
    dispatch(
      CertificatesActions.getCertificatesError(
        error.response?.data.message || error?.message
      )
    );
  }
  dispatch(CertificatesActions.clearState());
};

//get single certificate
export const getSingleCertificate = (id) => async (dispatch) => {
  try {
    dispatch(CertificatesActions.getSingleCertificateRequest());

    const response = await axiosReq({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/certificate/user/single/${id}`,
    });
    dispatch(CertificatesActions.getSingleCertificateSuccess(response.data));
  } catch (error) {
    toast.error(error.response?.data.message || error.message);
    dispatch(
      CertificatesActions.getSingleCertificateError(
        error.response?.data.message || error?.message
      )
    );
  }
  dispatch(CertificatesActions.clearState());
};

//clear state
export const clearState = () => (dispatch) => {
  setTimeout(() => {
    dispatch(CertificatesActions.clearState());
  }, 3000);
};
